/* Finite viewport reveals and routine guidance; no scroll interception or timers. */
(() => {
  const root = document.querySelector('.sr-home-page,.sr-routine-page');
  if (!root || root.dataset.srMotionReady) return;
  root.dataset.srMotionReady = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Map();
  let reveals;
  function finishMotion() {
    running.forEach(animation => animation.finish());
    running.clear();
    reveals?.disconnect();
  }
  if (!reduced.matches && 'IntersectionObserver' in window && root.animate) {
    const targets = root.querySelectorAll('.sr-start-section,.sr-home-shop>h2,.sr-shop-card,.sr-choice,.sr-picker-extras section>h2,.sr-trust-story>div,.sr-learn-section>h2,.sr-guide-card,.sr-support-strip>div,.sr-routine-evening,#extras>h2,.sr-next-lesson');
    reveals = new IntersectionObserver(entries => {
      entries.forEach(({target,isIntersecting}) => {
        if (!isIntersecting) return;
        reveals.unobserve(target);
        if (target.contains(document.activeElement)) return;
        const siblings = [...target.parentElement.children].filter(node => node.matches('.sr-shop-card,.sr-guide-card'));
        const delay = innerWidth > 750 ? Math.max(0, siblings.indexOf(target)) * 65 : 0;
        const animation = target.animate([
          {opacity:.25,transform:'translateY(18px)'},
          {opacity:1,transform:'translateY(0)'}
        ], {duration:650,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
        running.set(target,animation);
        animation.onfinish = () => running.delete(target);
      });
    }, {threshold:.06,rootMargin:'0px 0px -24px 0px'});
    targets.forEach(target => reveals.observe(target));
  }
  root.addEventListener('focusin', event => {
    running.forEach((animation,target) => { if (target.contains(event.target)) animation.finish(); });
  });
  reduced.addEventListener('change', event => { if (event.matches) finishMotion(); });

})();
